var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArtfreakLogoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.5 12.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1-2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.51,6.17h1.07l2.87,6.45H20.24l-.67-1.55H16.49l-.67,1.55H14.65l2.86-6.45m1.64,3.91L18,7.52l-1.12,2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.46,6.22h2.91a2.66,2.66,0,0,1,1.88.64,1.88,1.88,0,0,1,.54,1.38v0a1.93,1.93,0,0,1-1.55,1.94L28,12.62H26.64L25,10.38H23.61v2.24H22.46V6.22m2.82,3.17c.82,0,1.34-.42,1.34-1.07h0c0-.69-.5-1.07-1.34-1.07H23.61V9.39Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "30.91 7.33 28.84 7.33 28.84 6.29 34.13 6.29 34.13 7.33 32.06 7.33 32.06 12.62 30.91 12.62 30.91 7.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "35.48 6.29 40.34 6.29 40.34 7.31 36.63 7.31 36.63 8.99 39.92 8.99 39.92 10.01 36.63 10.01 36.63 12.62 35.48 12.62 35.48 6.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.78,6.22h2.91a2.68,2.68,0,0,1,1.88.64,1.92,1.92,0,0,1,.54,1.38v0a1.94,1.94,0,0,1-1.55,1.94l1.77,2.42H46l-1.6-2.24H42.92v2.24H41.78V6.22M44.6,9.39c.82,0,1.34-.42,1.34-1.07h0c0-.69-.5-1.07-1.35-1.07H42.92V9.39Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "48.88 6.29 53.72 6.29 53.72 7.29 50.03 7.29 50.03 8.89 53.3 8.89 53.3 9.9 50.03 9.9 50.03 11.61 53.77 11.61 53.77 12.62 48.88 12.62 48.88 6.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.78,6.17h1.06l2.87,6.45H60.5l-.67-1.55H56.75l-.67,1.55H54.9l2.88-6.45m1.64,3.91L58.29,7.52l-1.12,2.56Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "62.72 6.22 63.86 6.22 63.86 9.44 66.97 6.22 68.38 6.22 65.66 8.97 68.5 12.62 67.1 12.62 64.88 9.74 63.86 10.77 63.86 12.62 62.72 12.62 62.72 6.22"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 2.25,
    width: 2.71,
    height: 10.42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.83,
    width: 2.72,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.67,
    y: 2.25,
    width: 2.72,
    height: 10.42
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtfreakLogoBlack);
export default __webpack_public_path__ + "static/media/artfreak-logo-black.807b5a3fb876c559bf4f034f7c99f896.svg";
export { ForwardRef as ReactComponent };